export default "/static/webpack/media/wave.a2133f53.svg";